const issuer = import.meta.env.REACT_APP_OKTA_ISSUER;
const clientId = import.meta.env.REACT_APP_OKTA_CLIENT_ID;

if (!issuer) throw new Error("Missing REACT_APP_OKTA_ISSUER");
if (!clientId) throw new Error("Missing REACT_APP_OKTA_CLIENT_ID");

const oktaAuthConfig = {
  issuer,
  clientId,
  redirectUri: `${window.location.origin}/implicit/callback`,
  scopes: ["location-api:read", "openid", "email", "profile"],
};

const oktaSignInConfig = {
  baseUrl: import.meta.env.REACT_APP_OKTA_BASE_URL,
  clientId: import.meta.env.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/implicit/callback`,
  authParams: {
    issuer: import.meta.env.REACT_APP_OKTA_ISSUER,
  },
  // Additional documentation on config options can be found at https://github.com/okta/okta-signin-widget#basic-config-options
};

export { oktaAuthConfig, oktaSignInConfig };
